import { KlantConversationalModule } from '@klant/conversational/klant-conversational.module';
import { ConversationalChatErrorhandlerModule } from '@klant/conversational/conversational-chat-errorhandler/conversational-chat-errorhandler.module';
import { ConversationalChatInactivitypromptModule } from '@klant/conversational/conversational-chat-inactivityprompt/conversational-chat-inactivityprompt.module';
import { BasePathService } from '@klant/conversational-connector/services/base-path/base-path.service';
import { KlantConversationalConnectorComponent } from '@klant/conversational-connector/klant-conversational-connector.component';
import { KlantConversationalConnectorService } from '@klant/conversational-connector/klant-conversational-connector.service';
import { AccountService } from '@fp/interfaces/conversational/generated/api/account.service';
import { ConversationalChatOverlayMessageModule } from '@klant/conversational/conversational-chat-overlay-message/conversational-chat-overlay-message.module';

import { NgModule, provideAppInitializer, inject } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { ApButtonComponent } from '@ap/button';
import { ApContentPipe, ApContentService } from '@ap/content';
import { ApErrorComponent } from '@ap/error';
import { API_KEY, BASE_PATH, ConversationalChatResource, KlantService } from '@ap/interface-apic-conversational-chat';
import { ApAnalyticsService, ApPageviewDataService } from '@ap/analytics';
import { ApCookieService } from '@ap/persistence';

import { BASE_PATH as BASE_PATH_SEAMLY } from '../../fp/interfaces/apix-mono-klant-conversational/generated/variables';

export const getBasePath = (basePathService: BasePathService) => basePathService.getBasePath();

/**
 * @ngdoc module
 * @name KlantConversationalModule
 **/
@NgModule({
    declarations: [KlantConversationalConnectorComponent],
    exports: [KlantConversationalConnectorComponent],
    imports: [
        ApButtonComponent,
        ApContentPipe,
        ApErrorComponent,
        KlantConversationalModule,
        ConversationalChatErrorhandlerModule,
        ConversationalChatInactivitypromptModule,
        ConversationalChatOverlayMessageModule
    ],
    providers: [
        BasePathService,
        AccountService,
        ApAnalyticsService,
        ApContentService,
        ApCookieService,
        ApPageviewDataService,
        ConversationalChatResource,
        KlantService,
        KlantConversationalConnectorService,
        { provide: BASE_PATH, useValue: '/services/{<CONVERSATIONAL_ENDPOINT>}/api' },
        { provide: API_KEY, useValue: '{<CONVERSATIONAL_APIKEY>}' },
        {
            provide: BASE_PATH_SEAMLY,
            useFactory: getBasePath,
            deps: [BasePathService]
        },
        provideAppInitializer(() => {
            const basePathService = inject(BasePathService);
            return basePathService.init();
        }),
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class KlantConversationalConnectorModule {}
